/*
 * replaces snippets/product.liquid inline sticky CTA behavior for the product-page modern pass
 */

(function() {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function cleanText(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function buildStickyPriceMarkup(pricing) {
    if (!pricing) {
      return '';
    }

    var currentPrice = cleanText(
      pricing.querySelector('.price__discounted-new.price-original')
    ) || cleanText(pricing.querySelector('[data-price-new]'));

    var originalPrice = cleanText(
      pricing.querySelector('.price__original-new.del-price')
    );

    var savingsText = cleanText(
      pricing.querySelector('.product-grid-save .you-save')
    ) || cleanText(
      pricing.querySelector('.compare-price .you-save')
    ).replace(/^\|\s*/, '');

    if (!currentPrice) {
      return '';
    }

    var markup = '<div class="modern-product-page__sticky-price-row">';

    if (originalPrice) {
      markup += '<span class="modern-product-page__sticky-price-original">' + escapeHtml(originalPrice) + '</span>';
      markup += '<span class="modern-product-page__sticky-price-separator">/</span>';
    }

    markup += '<span class="modern-product-page__sticky-price-current">' + escapeHtml(currentPrice) + '</span>';
    markup += '</div>';

    if (savingsText) {
      markup += '<span class="modern-product-page__sticky-savings">' + escapeHtml(savingsText) + '</span>';
    }

    return markup;
  }

  function syncInventoryStatus(root, variantId) {
    root.querySelectorAll('.product-form__inventory-status').forEach(function(status) {
      var levels = Array.prototype.slice.call(status.querySelectorAll('[data-stock-level]'));

      if (!levels.length) {
        return;
      }

      var activeLevel = null;

      levels.forEach(function(level) {
        var isMatch = variantId && level.getAttribute('data-stock-variant-id') === String(variantId);
        level.setAttribute('data-stock-variant-selected', isMatch ? 'true' : 'false');

        if (isMatch) {
          activeLevel = level;
        }
      });

      if (!activeLevel) {
        activeLevel = levels.find(function(level) {
          return level.getAttribute('data-stock-variant-selected') === 'true';
        }) || levels[0];
        activeLevel.setAttribute('data-stock-variant-selected', 'true');
      }
    });
  }

  function syncJudgeMeFallback() {
    if (!window.jdgmSettings || window.jdgmSettings.review_widget_qna_enabled !== false) {
      return;
    }

    document.querySelectorAll('.jdgm-prev-badge, .jdgm-rev-widg, .jdgm-review-widget').forEach(function(widget) {
      if (widget.hasAttribute('data-number-of-questions')) {
        widget.setAttribute('data-number-of-questions', '0');
      }
    });

    document.querySelectorAll('.jdgm-ask-question-btn').forEach(function(button) {
      button.style.display = 'none';
    });

    document.querySelectorAll('.jdgm-rev-widg, .jdgm-review-widget').forEach(function(widget) {
      widget.querySelectorAll('[class*="question"], [class*="qna"]').forEach(function(node) {
        node.style.display = 'none';
        node.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function syncStickyBar(stickyBar, titleTarget, priceTarget, buttonTarget, sourceRoot) {
    var title = sourceRoot.querySelector('.product-title');
    var pricing = sourceRoot.querySelector('[data-product-pricing]');
    var button = sourceRoot.querySelector('.product-form--atc-button');

    if (!button) {
      stickyBar.hidden = true;
      return null;
    }

    titleTarget.textContent = title ? title.textContent.trim() : '';

    if (pricing) {
      priceTarget.innerHTML = buildStickyPriceMarkup(pricing);
    } else {
      priceTarget.innerHTML = '';
    }

    buttonTarget.textContent = button.textContent.replace(/\s+/g, ' ').trim();
    buttonTarget.disabled = button.disabled;

    return button;
  }

  function initModernProductPage(root) {
    var stickyBar = root.querySelector('[data-modern-product-sticky]');
    var titleTarget = root.querySelector('[data-modern-product-sticky-title]');
    var priceTarget = root.querySelector('[data-modern-product-sticky-price]');
    var buttonTarget = root.querySelector('[data-modern-product-sticky-button]');
    var formArea = root.querySelector('[data-product-form-regular]');
    var sourceArea = root.querySelector('.product-main') || root;
    var variantSelection = root.querySelector('variant-selection[data-variant-selection]');

    if (variantSelection) {
      syncInventoryStatus(root, variantSelection.getAttribute('variant'));

      variantSelection.addEventListener('variant-change', function(event) {
        var selectedVariant = event.detail && event.detail.variant ? event.detail.variant.id : null;
        syncInventoryStatus(root, selectedVariant);
      });
    } else {
      syncInventoryStatus(root, null);
    }

    if (!stickyBar || !titleTarget || !priceTarget || !buttonTarget || !formArea) {
      return;
    }

    var currentButton = syncStickyBar(stickyBar, titleTarget, priceTarget, buttonTarget, sourceArea);
    if (!currentButton) {
      return;
    }

    var mobileQuery = window.matchMedia('(max-width: 767px)');

    function updateVisibility(isVisible) {
      if (!mobileQuery.matches || !currentButton || currentButton.disabled) {
        stickyBar.classList.remove('is-visible');
        stickyBar.hidden = true;
        return;
      }

      stickyBar.hidden = isVisible;
      stickyBar.classList.toggle('is-visible', !isVisible);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        updateVisibility(entry.isIntersecting);
      });
    }, {
      threshold: 0.2
    });

    observer.observe(formArea);

    var mutationObserver = new MutationObserver(function() {
      currentButton = syncStickyBar(stickyBar, titleTarget, priceTarget, buttonTarget, sourceArea);
      updateVisibility(false);
    });

    mutationObserver.observe(sourceArea, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'disabled']
    });

    mobileQuery.addEventListener('change', function() {
      currentButton = syncStickyBar(stickyBar, titleTarget, priceTarget, buttonTarget, sourceArea);
      updateVisibility(false);
    });

    buttonTarget.addEventListener('click', function() {
      if (!currentButton || currentButton.disabled) {
        return;
      }

      currentButton.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      window.setTimeout(function() {
        currentButton.click();
      }, 120);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.modern-product-page').forEach(initModernProductPage);
    syncJudgeMeFallback();

    var judgeMeObserver = new MutationObserver(function() {
      syncJudgeMeFallback();
    });

    judgeMeObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
